import { Button, Col, Form, Input, Row, TimePicker } from "antd";
import React from "react";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import map from "lodash/map";
import get from "lodash/get";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

export const validateNoOverlap = (fieldListName, name) => {
  return ({ getFieldValue }) => ({
    validator(_, value) {
      const allBreaks = getFieldValue(fieldListName);
      const current = get(allBreaks, [name]);

      const rawStart = get(current, "start");
      const rawEnd = get(current, "end");

      const currentStart = dayjs(rawStart, "HH:mm");
      const currentEnd = dayjs(rawEnd, "HH:mm");

      if (!currentStart.isValid() || !currentEnd.isValid()) {
        return Promise.resolve(); 
      }

      const isOverlapping = map(allBreaks, (other, index) => {
        if (
          index === name ||
          !get(other, "start") ||
          !get(other, "end")
        )
          return false;

        const otherStart = dayjs(get(other, "start"), "HH:mm");
        const otherEnd = dayjs(get(other, "end"), "HH:mm");

        return (
          currentStart.isBefore(otherEnd) &&
          currentEnd.isAfter(otherStart)
        );
      }).some(Boolean);

      if (isOverlapping) {
        return Promise.reject(
          new Error("This break overlaps with another break.")
        );
      }

      return Promise.resolve();
    },
  });
};

const BreakTimeCompany = () => {
  return (
    <>
      <Form.List name="break_timings">
        {(fields, { add, remove }) => (
          <>
            {map(fields, ({ key, name, ...restField }) => (
              <Row gutter={10} key={key}>
                <Col xl={10}>
                  <Form.Item
                    {...restField}
                    name={[name, "name"]}
                    label={`Break ${name + 1}`}
                    rules={[
                      {
                        required: true,
                        message: "Please Input Break Name",
                      },
                    ]}
                  >
                    <Input placeholder="Break Name" />
                  </Form.Item>
                </Col>
                <Col xl={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "start"]}
                    label={"Start Time"}
                    rules={[
                      {
                        required: true,
                        message: "Please Input Start Time",
                      },
                      validateNoOverlap("break_timings", name),
                    ]}
                  >
                    <TimePicker
                      className="w-full"
                      placeholder="Start Time"
                      format={"HH:mm"}
                      minuteStep={15}
                    />
                  </Form.Item>
                </Col>
                <Col xl={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "end"]}
                    label={"End Time"}
                    rules={[
                      {
                        required: true,
                        message: "Please Input End Time",
                      },
                       validateNoOverlap("break_timings", name),
                    ]}
                  >
                    <TimePicker
                      className="w-full"
                      placeholder="End Time"
                      format={"HH:mm"}
                      minuteStep={15}
                    />
                  </Form.Item>
                </Col>
                <Col xs={2} className="pt-8 pl-8">
                    <MinusCircleOutlined onClick={() => remove(name)} />
                </Col>
              </Row>
            ))}
            <Row>
              <Col xl={24} className="max-w-[250px] mx-auto">
                <Form.Item className="mt-1 w-full">
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                  >
                    Add Break
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </>
        )}
      </Form.List>
    </>
  );
};

export default BreakTimeCompany;
